<template>
	<div class="_private-order-search">
		<input
			class="_private-order-search-input"
			:placeholder="placeholder"
			:value="keyword"
			@input="handleInput"
		/>

		<div class="icon-wrapper">
			<i class="bi bi-search"></i>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: {
		placeholder: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters({
			keyword: 'privateOrder/keyword',
		}),
	},
	methods: {
		...mapActions({
			setKeyword: 'privateOrder/setKeyword',
		}),
		handleInput(event) {
			this.setKeyword(event.target.value);
		},
	},
};
</script>

<style scoped lang="scss">
._private-order-search {
	width: 100%;
	height: 100%;
	min-width: 200px;
	max-height: 55px;
	background-color: #ffffff;
	border-radius: 360px;
	border: 2px solid rgba(0, 0, 0, 0.15);
	padding: 4px 8px 4px 4px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 4px;

	@media screen and (min-width: 600px) {
		padding: 10px;
	}

	& > .icon-wrapper {
		height: 100%;
		aspect-ratio: 1;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #1f1f1f99;

		@media screen and (min-width: 600px) {
			font-size: 20px;
		}
	}
}

._private-order-search-input {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	border: none;
	outline: none;
	box-shadow: none;
	padding-left: 10px;
	font-size: 12px;

	@media screen and (min-width: 600px) {
		font-size: 16px;
	}

	&:focus {
		border: none;
		outline: none;
		box-shadow: none;
	}
}
</style>
